(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWsheep_atlas_", frames: [[620,680,208,208],[428,956,176,176],[606,1120,152,194],[904,0,112,278],[904,280,112,278],[164,622,162,328],[0,622,162,328],[760,1140,166,136],[428,1134,166,136],[262,1186,156,136],[420,1272,156,136],[760,1278,142,148],[578,1316,130,156],[124,1186,136,158],[0,952,122,318],[364,312,178,332],[544,312,178,332],[724,346,178,332],[724,0,178,344],[278,956,148,228],[124,952,152,232],[830,680,176,228],[798,910,176,228],[620,890,176,228],[904,560,44,46],[362,0,360,310],[0,0,360,310],[0,312,362,308],[328,646,144,308],[474,646,144,308]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.SheepbackLeg_excited_003 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.SheepFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.SheepFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.SheepFrontLeg0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.SheepFrontLeg0002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0010001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0010002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0030001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0030002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0050002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0060002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.SheepHead_0070002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.SheepHindLegBack_excited_002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.SheepHindLeg0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.SheepHindLeg0002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.SheepHindLeg_excited = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.SheepHindLeg_excited_002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.SheepLegA_104 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.SheepLegA_108 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.SheepNeck0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.SheepNeck0002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.SheepNeck_excited = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.SheepTail0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.SheepTorso0001 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.SheepTorso0002 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.SheepTorso_excited = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.sheep_hindleg_01 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.sheep_hindleg_02 = function() {
	this.spriteSheet = ss["MWsheep_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.SheepWool2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AglJYIgCgFIgGAJQgSAdgiAAQgmAAgRghIgCgEQgNgDgMgJQgVAJgRAAQg4AAgWgjQgHgLgCgOIgBgLQABgFgBgCQhNgKgWgfQgKgOAAgrQAAgtAcgmQAUgdAfgPQgJgKgFgOQgGgUADgSQAEgcASgPIgGgBQgngHgLgjQgHgUADgTQAFggAYgSIADgBQgMgLgFgQQgGgWACgQQAGgfAXgRIACgBQgGgJgEgLQgFgTACgSIAAAAQgMgJgIgPQgKgUAAgSQAAgkAVgTQAKgJAMgDIgIgMQgLgUAAgSQAAghAUgVQATgTAbgBQAIAAAHABQgGgOAAgMQAAgkAVgTQASgRAbACQAPABAMAHQgDgKAAgJQAAgkAVgTQASgRAcACIAFABIAAgIQAAgkAVgTQASgQAbACQAbACATATIADADQAFgKAIgIQARgQAbACQAaACATASQAIAIAFAKQAEgJAHgGQASgQAcACQAaACATASIAJALQANgFAPABQAbACATASQAHAHAFAJIAGAAQAbADAPAVQARAYgGAlQgCANgLAPQAUAHANASQASAYgFAdQgCAQgOARQAQAFAMAPQARAYgGAkQgDASgSATQgGAHgFAEQAKAHAIAKQARAYgFAeQgDASgSATQgIAIgJAGQARAHANARQAQAXgFAdQgDASgRATIgKAJIAJAKQARAYgGAkQgEAUgQASQgNAPgQAEIACADQARAXgFAeQgDASgSATQgQASgUAEIABABQASAYgGAkQgDATgSATQgZAagfgFIgMgDIAHAIQASAXgFAdQgDATgSATQgWAYgegDQAKAVgFAcQgDATgSAUQgYAZgggFQgagEgNgSIgDAEQgTAdggAAQgkAAgSghgAgqIHIADAFIADgGIgGABgAhFnhIAEgCIgEAAIAAACg");
	this.shape.setTransform(39.2,63.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepWool2, new cjs.Rectangle(-2.3,0,82.9,126.7), null);


(lib.SheepWool = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AAwJCQgGgegEgIQgGADgTAEQgRAEgHAAQgqAAgKgpQgCgHAAgXQgUgGgNgTIgIgNQgKAFgMABQgqAEgWgfQgMgRgCgRQgCgOADgMQgNAIgRACQgpAFgXgfQgMgRgCgSQgEgaAOgUIgGABQgpAEgXgeQgMgRgCgSQgEggATgWIADgCQgPgHgLgOQgMgSgCgRQgEgfAUgWIABgCQgIgGgHgKQgLgPgEgRQgEggATgWQAGgHAHgFQgMgQgCgQQgEgkATgUQANgMASgFIgBgBQgNgSgCgRQgEggAUgXQAMgNARgGQgCgdARgTQASgSAdgBQAJgBAKACIgBgFQgFgkATgUQATgSAcgBQAJgBAJACQAAgYARgSQASgUAbgFQAbgEAWAOQACgUAMgOQASgSAdgBQAKAAALADIAHgLQASgRAdgCIAKAAIACgDQASgVAcgEQAdgEAVAQQAYARAFAlQACAMgIARQAXABATAOQAYARAEAdQABAQgJASQATABAQALQAYASAEAkQADARgNAXQgEAHgFAGQAMAEALAHQAZARADAeQACASgMAWQgHAKgIAIQAVACAQAMQAZARAEAdQACASgOAWQgDAHgEAFQAGADAGAEQAYASAEAjQADASgMAWQgJARgPAIIADADQAYARADAdQACARgMAXQgMAVgUAJIADABQAYARAFAkQACATgOAWQgRAfghADIgNAAIAJAHQAZAQADAdQACATgNAWQgPAcgfAGQAPAQAEAcQACATgMAXQgSAegiAEQgoAEgXgeQgEgFgCgFIgEACIAAACQAAARgiAfQgkAggcAAQgpAAgMgZg");
	this.shape.setTransform(36.8,58.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepWool, new cjs.Rectangle(-5.5,-1.9,84.8,120.7), null);


(lib.SheepSnout_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#79808E").s().p("AgqBjQgSgGgJgJQgLgJALghIAOgbQAGgNABg0QAAg2ASACQASADAdAsIAqA9QANATADARQADAQgNATQgNASgnAFQgRADgNAAQgQAAgJgEg");
	this.shape.setTransform(7.5,10.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepSnout_005, new cjs.Rectangle(0,0,15.1,20.6), null);


(lib.SheepNose_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AAAAMIgEgDIgHgEIgCgCQgLgHACgDQACgCAMAGQAKAFAAAGQAAABAAABQgBABAAABQAAAAAAAAQgBABAAAAIAAgBgAARgCQADgKACAAQACABgDAGIgEAJIgCAEIgBACIgBAAIAEgMg");
	this.shape.setTransform(3.2,2.9);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFCCFF").s().p("AgCARQgOgJgIgKQgJgKATgGQARgGAKAAQAKAAADAFQACAEAAAHQAAALgHAMQgFAKgCAAIgBAAQgDAAgMgIgAgSgDQgBADAKAHIACACIAHAEIADADQADACAAgGQABgGgLgGQgJgDgDAAIgCAAgAAWABIgEANIAAAAIABgCIACgEIAFgJQADgGgCgBIgBAAQgCAAgCAJg");
	this.shape_1.setTransform(2.8,2.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepNose_005, new cjs.Rectangle(0,0,5.6,5.1), null);


(lib.SheepLegWool2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ah4E4QgLgSAAgQIAAgCIgIABQglAAgTgfQgKgSAAgQQAAgQAGgMQgYgHgNgXIgKghQAAgeAQgRQgTgHgMgUQgKgSAAgQQAAgWAMgQQgRgIgKgSQgLgSAAgQQABgcASgSQgDgHgDgHQgHgVADgTQAAhaBagoQBQgkB2ANQBzAMBTAxQBMAtANA4QALAPgBATQAAARgOAUQgNASgSAGQAIAEAIAHQAVATAAAhQAAASgOATQgTAYgcACQALAPAAAUQAAARgOAUQgUAcggAAQAIAPgBAUQABASgOATQgUAbggAAQgKAAgHgCIAAALQAAASgOAUQgUAbgfAAQgYAAgPgMIgHAKQgTAbggAAQgnAAgRgfg");
	this.shape.setTransform(29.8,34.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepLegWool2, new cjs.Rectangle(0,0,59.5,68.6), null);


(lib.SheepLegWool = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgPFCIgCACQgTAbggAAQgmAAgSgfQgHgMgCgMQgMAGgOAAQgnAAgRgfQgHgOgCgNQgRAQgZAAQgnAAgSggQgIgQgCgQQAAgeAVgTIAMgJQgOgIgJgPQgIgQgCgSQAAgeAVgTQAMgMAQgEIgGgIQgKgRAAgRQAAgeAVgTQAOgOAVgEIgEgGQgKgRAAgRQAAghAVgRQASgPAaABQgHgOAAgNQAAghAUgRQATgQAbACQANABALAEQABgdAUgTQASgRAbgBQAbgBARAQQAMALAFAQQASgQAbACQAbABASARQAVATAAAcIgBAHQAPgHATABQAaABATARQAVATAAAcQAAAMgHAOIAHAAQAbACATARQAVASAAAcQAAARgNATQASAEAOAMQAVATAAAcQAAAQgPAVQgLAPgPAGIAEAEQAVATAAAhQAAASgPAUIgGAJIAAAAQAVASAAAiQAAARgPAUQgTAaghAAQgTAAgOgIIAAAKQAAASgOAUQgTAbghAAQghAAgRgYIgJALQgUAVggAAQgnAAgRgdg");
	this.shape.setTransform(33.4,35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepLegWool, new cjs.Rectangle(0,0,66.8,70.1), null);


(lib.SheepLegA_108_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepLegA_108();
	this.instance.parent = this;
	this.instance.setTransform(-1.5,-10.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepLegA_108_1, new cjs.Rectangle(-3,-10.8,77.5,116), null);


(lib.SheepLegA_104_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepLegA_104();
	this.instance.parent = this;
	this.instance.setTransform(-1.5,-8.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepLegA_104_1, new cjs.Rectangle(-3,-8.4,75.5,114), null);


(lib.SheepInnerEarA_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFCCFF").s().p("AAJAlQgMgIgJgPQgKgOgBgOQAAgOACgMIAMATQAWAcAGAMQAGAMgCAHQgBADgDAAQgDAAgHgEg");
	this.shape.setTransform(2.9,5.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepInnerEarA_006, new cjs.Rectangle(0.5,1,4.8,8.3), null);


(lib.SheepHoof = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#69727C").s().p("AhPAsQgbgPANgYQANgXAVgQIAcgUQAGgEAFAGQARAWAlAAQAqAAAHgDQAAgBAFAAQAHAAACAFIABAGQAAAOgNAYQgRAhgVADQgWAEgmABIgIAAQgjAAgXgMg");
	this.shape.setTransform(9.8,5.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepHoof, new cjs.Rectangle(0,0,19.6,11.3), null);


(lib.SheepHeadWool_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgNCXIgGABQgIAAgFgIQgCgEgBgDIgEAAQgMAAgDgJIAAgGIgCAAQgJAAgEgHIgCgHQAAgGADgEQgIgCgDgHIgDgLIAAgDIAAgCIgCgFQgHgCgEgJQgDgGAAgHQgBgIAFgGQgFgCgBgFIgBgFIABgGQgFgCgCgFIgCgIQAAgIADgIQgFgCgBgJQAAgGABgCQgEgDAAgJQgBgMAJgBIABgDQgKAAgBgNQAAgNALAAIgBgDQAAgNAKAAIAEABIAAgFQAAgMAKAAQAEAAADACQAAgLAKAAIAFABIgBgDQAAgMAKAAIAIACQAAgHAJAAQAFAAADADQABgHAJgBIACgBIACAAQAKAAADAGQABgDAFgBQAIgCACAGQADgCAEAAQAKgCACALIABADIAEgCQAKgBACAKQADgCAEgBQAKgCACANIABAEIAEgCQALgCACANIABADQAKgCACANQABAFgBAEQAPADABARQAAAIgEACIACAHQgCALgDAFQACADAAAHIAAAJQgBAGgFABQAEAFABAHQAAAIgBAFQACADAAAEQABAQgLACQADAEAAAGQgCAPgHAFIACAGQABARgPADIAAACQABAQgJACIAAAAQAAADgDAGQgCAGgDABQACADAAAFQABALgNAAIgGAAIAAACQgCAFgHAAQgKAAgEgEIAAABQgCAEgHAAQgJAAgDgCQgDAEgEAAQgMAAgDgIgAAbCLIAAAAIgBAAgAgNCJIABAAIgBgBIAAABgAhGA6IABAAIAAAAgAhTAEIABAAIAAgBgABXgLIABAAIgBgBg");
	this.shape.setTransform(11.8,15.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepHeadWool_005, new cjs.Rectangle(0,0,23.6,31.8), null);


(lib.SheepForeheadWool_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhpBOIABgBQgFgBgBgFIgBgFQAAgHAFgEIAAgCQAAgEAEgCIgBgEQAAgEACgCIAAgBIgCgCIgBgCIgBgGQAAgGADgDIgBgBQAAgEACgCIAAAAIgCgJIABgEIgBgCIgBgEQAAgHAFgBIgBgCIgBgDQAAgCAGgDIAAgBQAAgBAAAAQAAgBABgBQAAAAABAAQAAAAABAAIAEgCIACAAIABAAIAEgCIADgGQADgEAGAAIABAAIABgBIgBAAIgBgDQACgMAMgCIAFAAQABgEAJgIQAIgJAZADIATAAQAfACARALQAHAEAOAPIAKALQAEAGAAAGIADAWIAAABQABADAAAEIAAACQACACAAAGIAAAEQALABAAAMQAAAFgQAEQABgJgBgGQgEgCgDgEQgDgFAAgFIAAgDIAAAAQgDABgGgEQgFgDAAgCIgBgBIgCgDIAAgBIgBgCIgBgEIgDABIgEABQgKAAgFgGIgDgGIABgCQgEACgFAAQgIAAgEgFIgCADQgFAFgGAAQgFAAgEgDQgBAEgCAAQgGAAgHgCIgHAGQgGACgJgHIgCADQgEAEgDAAQgCACgDAAIgEgBIACACQAAAEgDAGQgDAHgDAAIgEABIAAAAIAAAEIgBAIQAAAEgIAJIgDAEIgEADIAAABQAAAKgIACQACAEAAAIQAAAGgDADIAAACIgDAEQgDADgCAAQgFAAAAgFg");
	this.shape.setTransform(11.2,8.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepForeheadWool_005, new cjs.Rectangle(0,0,22.4,16.6), null);


(lib.SheepFace_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#79808E").s().p("AAOCHQAHgLg7gqQg8gqAHhOQAHhQAOgIQARgLAygCQAXgBAYAcQAPARAJARQAKAWgDAPQgDALAMAaQAMAYgEAGQgEAHABAaIgBArQAAASgpANQgXAHgHAAQgHAAAEgFg");
	this.shape.setTransform(9.4,14.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepFace_005, new cjs.Rectangle(0.1,0.3,18.6,28), null);


(lib.SheepEye_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgEAAQAAgEAEAAQAFAAAAAEIgBADIgEACQgEAAAAgFg");
	this.shape.setTransform(2.2,1.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AgBARQgOgBgBgKQgBgIAEgGQAFgFAIgCQAJgCAFAFQAFAFgCAHQgEARgNAAIgBAAgAAAgEQAAAEAFAAIADgBIACgDQAAgFgFAAQgFAAAAAFg");
	this.shape_1.setTransform(1.7,1.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepEye_001, new cjs.Rectangle(0,0,3.5,3.4), null);


(lib.SheepEarB_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#666666").s().p("AgMA0QgOgDAGgqQAGgpAKgKQAIgLAEADQADACAGAZQAGAZAAASQAAAUgEAHQgFAIgFABIgVgCg");
	this.shape.setTransform(2.3,5.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepEarB_005, new cjs.Rectangle(0,0,4.6,10.7), null);


(lib.SheepbackLeg_excited_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepbackLeg_excited_003();
	this.instance.parent = this;
	this.instance.setTransform(-1,-5.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepbackLeg_excited_003_1, new cjs.Rectangle(-7.1,-8.1,82.1,99.6), null);


(lib.sheep_noseGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ACcgDQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sheep_noseGlow, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.sheep_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AiGguQgEgGAAgGQAAgGABgEQgCAAgCAAQgHAAgKgYQgLgYAFgEQCKhXBcArQBLAiAWBnQAIAkgMA8QgFAegIAXQgFAZgNAPQgLALgOAGQAAgBAAgBQgCgBgBgCQAAgBAAAAQgGAGgKAAQgOAAgGgLQgCgDgBgDQgBgEAAgDQAAgCABgDQgFACgFAAQgOAAgGgMQgEgGAAgGQAAgBAAgBQgEACgFAAQgOAAgGgMQgDgGAAgGQAAgGABgEQgCAAgCAAQgOAAgHgLQgEgGAAgGQAAgJAEgGQgFACgFAAQgOAAgGgLQgEgHAAgGQAAgCABgBQgKgDgFgIQgEgHAAgGQAAgGABgDQgCABgCAAQgOAAgGgMQgEgGAAgGQAAgGABgFQgDABgEAAQgOAAgGgLg");
	this.shape.setTransform(21.5,52.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sheep_neckGlow, new cjs.Rectangle(2.9,32.2,37.3,39.9), null);


(lib.sheep_mouthMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(23));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AhFBtQgHgEgKABQgRACgEgFQgBgHgDgDIgIgFQgHgFgBgDIgCgFQgBgDgGgFIgRgOQgKgJgCgGQgBgFgEgBQgDgCAJgBQAJgBgHgFQgHgFAJgJQAKgJADABIAJADQAGACgHgIQgJgTAQAAIAFABQATg5ATAAIAGABQAFgIAPgEQALgCAGAEQAEgJAGgGQAKgLARAAQAMAAAKAKQAGAFACAFIAMgJQAFgEALAAQAOAAAMANIAKAMIAJgCQAHgCAGAAQAPAAAEAOIABACQADgCAFAAQAQgCAAAOQAAAEgHAGIABABQARAIAGALQAEAHAAANQAAANgSATQgQARgLABQgCAHgCADQgGAFgRACIgIAHQgHAFgHAAQgGAAgFgDQgEgDgDAAIgHACQgEAAgEgCIgFgCIgIAIQgIAIgIgDQABAKgEADQgFAFgVAGQgNANgQAAQgTAAgIgEg");
	this.shape.setTransform(17.2,11.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(23));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,34.4,22.6);


(lib.sheep_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ACPAtQACgEAFgDQgCgCgBgDQgHgCgEgFQgKgEgIgIQgGgGgEgHQgEgGgDgHIgBgEQgCgHgBgGQAAAAAAgBIAAAAQAAgBAAAAIAAgBQAAAAAAgBQAAgCAAgCQAAAAAAgBIAFgaQADgHAEgGQACgCACgCIABAAQAAgBABAAQgBgCgBgBQgCgEgBgEQgFgEgDgFQgCgDgCgDQgJgOgDgRQgCgeAPgUQAFgGAFgEQgBgCgBgBQgDgHgBgGQAAgKAEgGQgCgHgBgIIAAgBQgDgdAQgTQACgDACgCQgDgEAAgFQAAgTAOgDQAAgBgBAAQgEgHAAgGQAAgGACgEQAAgKABgIQABgSALgMQAHgIAJgEQAHgDAIgBQAAgDABgDQgEgKgBgJQgDgbALgRQACgEADgDQANgQAXgBQAKAAAKAEQgBgOADgLIACgHIACgEQADgHAEgFQAGgIAIgFIAFgDIAIgDQAEgCAEAAQABAAACAAQAUgDAQAOQAIAHAFAJQAAAAABAAQAFABAEABQANgKARgBQARAAAPAJQAWACABAWQAGgGAMABQAYABAAAWQAAADgBADQAHABAHADQADABADACQAFADAFAEQAMAKAFAPQAOAEAAASQAAACAAACQAWACAAAVQAAABAAABQAEACAEADIACACIAPATQAGALABANQABAKgEAMQgBADgBAEQACADABAFQAHACAHAEQAEADAFADQASARACAbQAAAAAAABQAAAAAAABIgBARQgCAIgFAKQgEAJgGAGQgFAFgEADQAAABABAAQABABABABQAHAGAFAJQAIAOACAUQABANgGAPQgBAFgDAFQgBACgBACQgBACgBADQAFAEADAGQALAOACAYQACARgKAUQgOAagbACQgCABgCAAQgGACgHABQAEAEADAFIABACQADAGABAIQABAIgFAKQgCAGgEAGQgJAOgOAGQgIADgKABQAHALABAPQABAOgKAPQgOAWgcACQgDABgCAAQgDAEgFACQAAABAAAAQABAOgLAQQgLARgSAFQgGACgHABQgDAAgCAAQgMAsgWBBQgDAKgDAJQgZBMgBAGQACAIAAAQQABAKgBAGQAAAOgMAAQgHAAgGgHQgEADgMAJQgEAFgCAFQAAABAAABQAAAHgFAMQgEASgOALQgHAHgJABQgBABgCAAQgJACgaABIgCAAQgDAAgDAAQgeABgUgKQgIgEgBgDIAAAAQgIgJAHgNQAKgTAPgMQALgIAHgEQAIgIAIgGQAUgPAAgBQAcgYAKgUQAIgRAHgpQAAgBAAgBQAEgYgCgqQgBgigCgIQgDgLgDgIQgBgCgBgCIgCgFQgBgCAAgCQgEACgGAAQgBAAgBAAQgJgBgFgGQgTgDgMgPQgKgNgBgMQAAgCAAgDQgNAAgGgLQgEgGAAgGQAAgDAAgBQgEgEgDgEQgCgDgBgCQgJgIgBgCQgEgHAAgGQAAgKAFgGQgEABgEAAQgOAAgHgMQgDgGAAgGQAAgIADgGgACbArQgGABgGABAEODYQABACAAACIABACQAAABAAAAQAAADgDAEQgDAFgGAAQgGAAgDgDQgBAAgCABQgBAHgDAJIgiBTQgGAMgGAMQgOAegNAbQAAACADAKQADAKgFANQgCAFgCAEQgEAIgFAFQgIAIgIgNQAAgEgRAOQgLAJgGAHQgBACgBABQgBAEgCADQAAABgBACQAAABgBABQgCAEgEACIgCABQgEABgEABQgFADgGABIgHACQgNADgMgBIgfgEQgFgBgGgCQgggMAVgbIAAABQAAAAAAgBIAAABQACgEAEgEIAJgIQAEgDAGgDQABAAABgBQADgBADgCQAAAAABAAQABAAACgBIACgBQACAAADgBQAAgBABAAQAqgfALgMQAPgRALgWQACgEACgGQAGgMAHgVQAGgRADgYQAEgYgBgSQABgHABgGQgEgBgDgEQgCgCAAgFQAAgDABgCQgGgDgBgIQAAgDABgCQgBAAAAAAQgLAAgBgMQAAgBAAAAQgKgBgBgLIAAgBQABgLAJAAQAygXAOgNAEODYQgBgBAAAAQAIgHAHgIQABAHAEAIAkcnVQAEgBAFAAIADAAQAAAAABAAQATACAOAQQAPASAAAcIAAAIQgBAIgDAHQAGAAAFADQAGABAGADIAPANQAQASAAAaQAAARgKASQAOAEAKAMQAPASAAAcQAAAAAAABIgDARQgCAJgFAJQgHALgHAGQgBABgBABQgCABgCABQACABABACQABACABABQAAABABAAQABABAAABQAMARAAAcQAAAPgIAPQgBAEgCADQgBACgBABQgBABAAABQgBABgBACIAAABQABAAABABQAOASAAAfQAAAOgIAOQgBADgCAEQgDAFgEAEIgCADQgHAIgJADIgEAPQgCAGgCAGQAEACABAGIAAADQAAAEgCADQgEAFgGAAQAAAAgBAAIAAABQACACABAEIAAADQAAADgDADQgDAFgEAAQAHADAAAIQAAAEgDADQgDAFgGAAQgEAAgCgCQgCAEgCAEQAEACACADIABAEIAAABQAAAAAAABQAAADgDAEQgDAFgGAAIgCAAQgDgBgCgBIAAABQAHACAAAKQAAADgDADQgDAFgGAAIgBAAIgDAAQgDgBgCgCIAAAAIAAAAQABABABABQACADAAAFQAAADgDAEQgDAEgGAAIgDAAQgDAAgDgDQgBABgBABQAAACAAACIAAABQAAADgCAEQgEAFgGAAQgCAAgBgBQAAACAAACQAAADgCAEQgEAFgGAAQgHAAgDgGQAAgBgBgBQAAgBAAgBQgBAAAAAAQAAACAAACQAAADgDAEQgDAFgGAAQgBAAgBAAQAAAEAAAFIAAADQABALAAAKQABAmAWA3QAKAbAKAaQAAAGAEASQAAAHgEAEQgFAFgKAAIgKAMQgCAFgBAFQAEACACACQAGAGgDAMQgHAYgZAGQgZAHgZgMQgCAAgBgBQgBgBgBAAQgDgBgDgCQgHgEAAgDQgBgHAFgMQAJgWAagVQACgBACgCQAIgmgBgDQgBgbgEgWQgBgCgFgbQgDgPgQg0QgDgKgDgIQgFgCgFgDQgBACgCADIgBACQgBAAAAAAQgEAGgFAEIgBABQgCACgCABIgBAAIAAABQgBAGgCAEQgDAGgGAEQgCAKgHAPQgLAWAAAXQAAALAJAoQAJAoAAAAQAAAFAAAEQAAAJAAABQgFAPgVACQgEAAgGAJQgFAJAAADQAAAfgCAGIgCAGQgFAJgHAFQgDAEgCACQgFAFgFABQgNADgXABQgYABgQgKQgPgLAHgSQAIgTAMgMIALgJQAEgEACgCQAAAAABAAQACgCACABQABgBABgBIAEgFQADgDACgDQAIgKAHgNQAVgmABg2QAAgPgJg4QgJg0AAAAQAAgBAAAAQAAgBAAAAQAAgBAAAAIAAgKQAAgFABgEQgIgDgGgFIgLgNQgIgOAAgMQAAgMAFgJQgSgFgKgRQgIgZAAgBQAAgPAFgKQAAgHACgFQgIgEgGgIIgEgGQgGgLgBgJQgKgDgIgHIgNgTQgGgPgBgRIAAAAQAAgcAPgTQAFgFAEgEQgKgIgHgOQgGgPgBgSQAAgdAPgTQAHgIAJgFQAAAAABAAQAAgDABgDQgBgBgBgDQgFgNgCgMIAAgJQAAgdAPgSQABgBAAAAIAAAAQAAgBAAgBQAAgXAUAAQgFgPAAgPQAAgQAEgNIALgUQAIgJALgDQAFgDAIAAQgDgHgBgIIgBgIQAAgBAAAAQAAggAPgRQAOgPAUABIAAAAIAFABQAGACAHADQAAgXAKgQQACgEADgEQAHgIAIgFIASgFQAUgBANAQQAJALAEAPQANgPAUABQABABAAgBIAWAIQAGAEAFAGQALAOADASQAJAEADALg");
	this.shape.setTransform(-8.6,57.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sheep_legGlow, new cjs.Rectangle(-74.2,-2,131.3,119.7), null);


(lib.sheep_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AGcAoQgYAWgEADQgnAagqAaQhUAthkAKQh1AFhwgaQiAggh7hBIgWgRQAAgJgEgFQgGgFgHgHQgEgDgHABQAAgBAAgBQgHgHgFgHQAIgBAHACQAAgSAPgOQAQgPAZgDQAZgEATALQACgPALgKQAQgOAagBQAKAAAKACQADgEAEgEQAPgNAbgBQAEAAAFAAQABgBABgBQAQgQAZgDQAbgDASAMQAJAFAFAHQAGAAAGABQAQgXAegDQAkgDAUAXQAEADACAFQACgCACAAQAAgBAAgBQAAgNAegXQAhgZAZAAQAlAAAKATQAGAXADAGQAGgCARgDQARgDAGAAQAmAAAJAfQACAFAAATQASAEALAOQAFAGADAFQAJgEALgBQAVgCAQAHQALAFAJAKQAGAHADAHQAWAkgXAWg");
	this.shape.setTransform(42.4,17.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sheep_backGlow, new cjs.Rectangle(-2,-2,88.8,38.5), null);


(lib.noseglowblue = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACcgDQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.noseglowblue, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.legsblueglow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACPAtQACgEAFgDQgCgCgBgDQgHgCgEgFQgKgEgIgIQgGgGgEgHQgEgGgDgHIgBgEQgCgHgBgGQAAAAAAgBIAAAAQAAgBAAAAIAAgBQAAAAAAgBQAAgCAAgCQAAAAAAgBIAFgaQADgHAEgGQACgCACgCIABAAQAAgBABAAQgBgCgBgBQgCgEgBgEQgFgEgDgFQgCgDgCgDQgJgOgDgRQgCgeAPgUQAFgGAFgEQgBgCgBgBQgDgHgBgGQAAgKAEgGQgCgHgBgIIAAgBQgDgdAQgTQACgDACgCQgDgEAAgFQAAgTAOgDQAAgBgBAAQgEgHAAgGQAAgGACgEQAAgKABgIQABgSALgMQAHgIAJgEQAHgDAIgBQAAgDABgDQgEgKgBgJQgDgbALgRQACgEADgDQANgQAXgBQAKAAAKAEQgBgOADgLIACgHIACgEQADgHAEgFQAGgIAIgFIAFgDIAIgDQAEgCAEAAQABAAACAAQAUgDAQAOQAIAHAFAJQAAAAABAAQAFABAEABQANgKARgBQARAAAPAJQAWACABAWQAGgGAMABQAYABAAAWQAAADgBADQAHABAHADQADABADACQAFADAFAEQAMAKAFAPQAOAEAAASQAAACAAACQAWACAAAVQAAABAAABQAEACAEADIACACIAPATQAGALABANQABAKgEAMQgBADgBAEQACADABAFQAHACAHAEQAEADAFADQASARACAbQAAAAAAABQAAAAAAABIgBARQgCAIgFAKQgEAJgGAGQgFAFgEADQAAABABAAQABABABABQAHAGAFAJQAIAOACAUQABANgGAPQgBAFgDAFQgBACgBACQgBACgBADQAFAEADAGQALAOACAYQACARgKAUQgOAagbACQgCABgCAAQgGACgHABQAEAEADAFIABACQADAGABAIQABAIgFAKQgCAGgEAGQgJAOgOAGQgIADgKABQAHALABAPQABAOgKAPQgOAWgcACQgDABgCAAQgDAEgFACQAAABAAAAQABAOgLAQQgLARgSAFQgGACgHABQgDAAgCAAQgMAsgWBBQgDAKgDAJQgZBMgBAGQACAIAAAQQABAKgBAGQAAAOgMAAQgHAAgGgHQgEADgMAJQgEAFgCAFQAAABAAABQAAAHgFAMQgEASgOALQgHAHgJABQgBABgCAAQgJACgaABIgCAAQgDAAgDAAQgeABgUgKQgIgEgBgDIAAAAQgIgJAHgNQAKgTAPgMQALgIAHgEQAIgIAIgGQAUgPAAgBQAcgYAKgUQAIgRAHgpQAAgBAAgBQAEgYgCgqQgBgigCgIQgDgLgDgIQgBgCgBgCIgCgFQgBgCAAgCQgEACgGAAQgBAAgBAAQgJgBgFgGQgTgDgMgPQgKgNgBgMQAAgCAAgDQgNAAgGgLQgEgGAAgGQAAgDAAgBQgEgEgDgEQgCgDgBgCQgJgIgBgCQgEgHAAgGQAAgKAFgGQgEABgEAAQgOAAgHgMQgDgGAAgGQAAgIADgGgACbArQgGABgGABAEODYQABACAAACIABACQAAABAAAAQAAADgDAEQgDAFgGAAQgGAAgDgDQgBAAgCABQgBAHgDAJIgiBTQgGAMgGAMQgOAegNAbQAAACADAKQADAKgFANQgCAFgCAEQgEAIgFAFQgIAIgIgNQAAgEgRAOQgLAJgGAHQgBACgBABQgBAEgCADQAAABgBACQAAABgBABQgCAEgEACIgCABQgEABgEABQgFADgGABIgHACQgNADgMgBIgfgEQgFgBgGgCQgggMAVgbIAAABQAAAAAAgBIAAABQACgEAEgEIAJgIQAEgDAGgDQABAAABgBQADgBADgCQAAAAABAAQABAAACgBIACgBQACAAADgBQAAgBABAAQAqgfALgMQAPgRALgWQACgEACgGQAGgMAHgVQAGgRADgYQAEgYgBgSQABgHABgGQgEgBgDgEQgCgCAAgFQAAgDABgCQgGgDgBgIQAAgDABgCQgBAAAAAAQgLAAgBgMQAAgBAAAAQgKgBgBgLIAAgBQABgLAJAAQAygXAOgNAEODYQgBgBAAAAQAIgHAHgIQABAHAEAIAkcnVQAEgBAFAAIADAAQAAAAABAAQATACAOAQQAPASAAAcIAAAIQgBAIgDAHQAGAAAFADQAGABAGADIAPANQAQASAAAaQAAARgKASQAOAEAKAMQAPASAAAcQAAAAAAABIgDARQgCAJgFAJQgHALgHAGQgBABgBABQgCABgCABQACABABACQABACABABQAAABABAAQABABAAABQAMARAAAcQAAAPgIAPQgBAEgCADQgBACgBABQgBABAAABQgBABgBACIAAABQABAAABABQAOASAAAfQAAAOgIAOQgBADgCAEQgDAFgEAEIgCADQgHAIgJADIgEAPQgCAGgCAGQAEACABAGIAAADQAAAEgCADQgEAFgGAAQAAAAgBAAIAAABQACACABAEIAAADQAAADgDADQgDAFgEAAQAHADAAAIQAAAEgDADQgDAFgGAAQgEAAgCgCQgCAEgCAEQAEACACADIABAEIAAABQAAAAAAABQAAADgDAEQgDAFgGAAIgCAAQgDgBgCgBIAAABQAHACAAAKQAAADgDADQgDAFgGAAIgBAAIgDAAQgDgBgCgCIAAAAIAAAAQABABABABQACADAAAFQAAADgDAEQgDAEgGAAIgDAAQgDAAgDgDQgBABgBABQAAACAAACIAAABQAAADgCAEQgEAFgGAAQgCAAgBgBQAAACAAACQAAADgCAEQgEAFgGAAQgHAAgDgGQAAgBgBgBQAAgBAAgBQgBAAAAAAQAAACAAACQAAADgDAEQgDAFgGAAQgBAAgBAAQAAAEAAAFIAAADQABALAAAKQABAmAWA3QAKAbAKAaQAAAGAEASQAAAHgEAEQgFAFgKAAIgKAMQgCAFgBAFQAEACACACQAGAGgDAMQgHAYgZAGQgZAHgZgMQgCAAgBgBQgBgBgBAAQgDgBgDgCQgHgEAAgDQgBgHAFgMQAJgWAagVQACgBACgCQAIgmgBgDQgBgbgEgWQgBgCgFgbQgDgPgQg0QgDgKgDgIQgFgCgFgDQgBACgCADIgBACQgBAAAAAAQgEAGgFAEIgBABQgCACgCABIgBAAIAAABQgBAGgCAEQgDAGgGAEQgCAKgHAPQgLAWAAAXQAAALAJAoQAJAoAAAAQAAAFAAAEQAAAJAAABQgFAPgVACQgEAAgGAJQgFAJAAADQAAAfgCAGIgCAGQgFAJgHAFQgDAEgCACQgFAFgFABQgNADgXABQgYABgQgKQgPgLAHgSQAIgTAMgMIALgJQAEgEACgCQAAAAABAAQACgCACABQABgBABgBIAEgFQADgDACgDQAIgKAHgNQAVgmABg2QAAgPgJg4QgJg0AAAAQAAgBAAAAQAAgBAAAAQAAgBAAAAIAAgKQAAgFABgEQgIgDgGgFIgLgNQgIgOAAgMQAAgMAFgJQgSgFgKgRQgIgZAAgBQAAgPAFgKQAAgHACgFQgIgEgGgIIgEgGQgGgLgBgJQgKgDgIgHIgNgTQgGgPgBgRIAAAAQAAgcAPgTQAFgFAEgEQgKgIgHgOQgGgPgBgSQAAgdAPgTQAHgIAJgFQAAAAABAAQAAgDABgDQgBgBgBgDQgFgNgCgMIAAgJQAAgdAPgSQABgBAAAAIAAAAQAAgBAAgBQAAgXAUAAQgFgPAAgPQAAgQAEgNIALgUQAIgJALgDQAFgDAIAAQgDgHgBgIIgBgIQAAgBAAAAQAAggAPgRQAOgPAUABIAAAAIAFABQAGACAHADQAAgXAKgQQACgEADgEQAHgIAIgFIASgFQAUgBANAQQAJALAEAPQANgPAUABQABABAAgBIAWAIQAGAEAFAGQALAOADASQAJAEADALg");
	this.shape.setTransform(-8.6,57.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.legsblueglow, new cjs.Rectangle(-74.2,-2,131.3,119.7), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.innerSheeptail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.SheepTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-0.9,-0.9,0.207,0.207);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.innerSheeptail, new cjs.Rectangle(-0.9,-0.9,9.1,9.5), null);


(lib.bluenoseglow5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACcgDQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow5, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.bluenoseglow4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AiIgoQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow4, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.bluenoseglow3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACcgDQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow3, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.bluenoseglow2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ACcgDQgFAHgKAMQgUAYgfAUQgIAGgfAGQgeAFgIAHQgMAPgHAGQgOALglAAQgpAAgYgrQgYgFgIgZIgDgeQAAgYAVgdQAKgRAPgOQATgjAvgHQAugHBFAZQBGAaAKAdQALAdgFAIg");
	this.shape.setTransform(15.8,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow2, new cjs.Rectangle(-2,-0.1,35.6,27.2), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AiGguQgEgGAAgGQAAgGABgEQgCAAgCAAQgHAAgKgYQgLgYAFgEQCKhXBcArQBLAiAWBnQAIAkgMA8QgFAegIAXQgFAZgNAPQgLALgOAGQAAgBAAgBQgCgBgBgCQAAgBAAAAQgGAGgKAAQgOAAgGgLQgCgDgBgDQgBgEAAgDQAAgCABgDQgFACgFAAQgOAAgGgMQgEgGAAgGQAAgBAAgBQgEACgFAAQgOAAgGgMQgDgGAAgGQAAgGABgEQgCAAgCAAQgOAAgHgLQgEgGAAgGQAAgJAEgGQgFACgFAAQgOAAgGgLQgEgHAAgGQAAgCABgBQgKgDgFgIQgEgHAAgGQAAgGABgDQgCABgCAAQgOAAgGgMQgEgGAAgGQAAgGABgFQgDABgEAAQgOAAgGgLg");
	this.shape.setTransform(21.5,52.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(2.9,32.2,37.3,39.9), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AGcAoQgYAWgEADQgnAagqAaQhUAthkAKQh1AFhwgaQiAggh7hBIgWgRQAAgJgEgFQgGgFgHgHQgEgDgHABQAAgBAAgBQgHgHgFgHQAIgBAHACQAAgSAPgOQAQgPAZgDQAZgEATALQACgPALgKQAQgOAagBQAKAAAKACQADgEAEgEQAPgNAbgBQAEAAAFAAQABgBABgBQAQgQAZgDQAbgDASAMQAJAFAFAHQAGAAAGABQAQgXAegDQAkgDAUAXQAEADACAFQACgCACAAQAAgBAAgBQAAgNAegXQAhgZAZAAQAlAAAKATQAGAXADAGQAGgCARgDQARgDAGAAQAmAAAJAfQACAFAAATQASAEALAOQAFAGADAFQAJgEALgBQAVgCAQAHQALAFAJAKQAGAHADAHQAWAkgXAWg");
	this.shape.setTransform(42.4,17.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-2,-2,88.8,38.5), null);


(lib.SheepTorso_excited_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.SheepTorso_excited();
	this.instance.parent = this;
	this.instance.setTransform(-99,-77.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepTorso_excited_1, new cjs.Rectangle(-99,-77.9,181,154), null);


(lib.SheepNeck_excited_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepNeck_excited();
	this.instance.parent = this;
	this.instance.setTransform(-42.2,-45.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepNeck_excited_1, new cjs.Rectangle(-42.2,-45.6,88,114), null);


(lib.SheepHindLegBack_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepHindLegBack_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-28.5,-53.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepHindLegBack_excited_002_1, new cjs.Rectangle(-28.5,-53.4,61,159), null);


(lib.SheepHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:155,glowclean:156,glowclean_loop:157,"final":158,final_loop:159});

	// Layer 3
	this.instance = new lib.sheep_hindleg_01();
	this.instance.parent = this;
	this.instance.setTransform(-39.9,-53.7,0.5,0.5);

	this.instance_1 = new lib.sheep_hindleg_02();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-39.9,-53.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},150).to({state:[]},4).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-39.9,-53.7,87,154);


(lib.SheepHindLeg_excited_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepHindLeg_excited_002();
	this.instance.parent = this;
	this.instance.setTransform(-39.5,-59.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepHindLeg_excited_002_1, new cjs.Rectangle(-43.5,-62.3,93,174.9), null);


(lib.SheepHindLeg_excited_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepHindLeg_excited();
	this.instance.parent = this;
	this.instance.setTransform(-39.5,-59.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepHindLeg_excited_1, new cjs.Rectangle(-43.5,-62.3,93,168.9), null);


(lib.SheepHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 4
	this.instance = new lib.SheepHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-39.9,-59.4,0.5,0.5);

	this.instance_1 = new lib.SheepHindLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-39.9,-59.4,0.5,0.5);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},150).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({_off:false},0).to({_off:true},2).wait(2).to({_off:false},0).wait(152).to({_off:true},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-43.5,-62.3,92.6,168.9);


(lib.SheepFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 7
	this.instance = new lib.SheepFrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-26.4,-44.4,0.5,0.5);

	this.instance_1 = new lib.SheepFrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-26.4,-44.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},150).to({state:[]},4).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-26.4,-44.4,100.8,139);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.SheepTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.innerSheeptail();
	this.instance.parent = this;
	this.instance.setTransform(-3.4,1,2.488,2.488,0,0,0,1.2,1.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(59).to({rotation:-35},2).to({rotation:0},3).wait(134));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.6,-4.9,22.7,23.8);


(lib.SheepFaceSnout_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SheepSnout_005();
	this.instance.parent = this;
	this.instance.setTransform(14.9,18.3,1,1,0,0,0,7.2,10.1);

	this.instance_1 = new lib.SheepFace_005();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.5,14,1,1,0,0,0,9.6,14.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepFaceSnout_005, new cjs.Rectangle(0,0,22.8,28.7), null);


(lib.SheepEarA_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SheepInnerEarA_006();
	this.instance.parent = this;
	this.instance.setTransform(4.2,7.6,1,1,0,0,0,2.7,4.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#79808E").s().p("AAZA/QgGAAgNgKIgTgOQgJgFgEgKIgFgRQgCgHgCgVQgDgXABgFQAEgTALAIQAZAXAUAWQAJAJACAKIABASIADARQAAAGgBAHIgEAIQgCADgEAAIgCAAg");
	this.shape.setTransform(4.7,7.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepEarA_006, new cjs.Rectangle(0.9,1.3,7.6,12.7), null);


(lib.SheepbackLeg_excited_003copy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SheepLegWool();
	this.instance.parent = this;
	this.instance.setTransform(24.6,26.1,0.701,0.84,0,-10.6,174.8,33.4,35.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance.filters = [new cjs.ColorFilter(0.85, 0.85, 0.85, 1, 0, 0, 0, 0)];
	this.instance.cache(-2,-2,71,74);

	this.instance_1 = new lib.SheepLegWool2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(28.5,46.1,0.72,0.655,0,-10.6,174.8,29.9,34.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance_1.filters = [new cjs.ColorFilter(0.85, 0.85, 0.85, 1, 0, 0, 0, 0)];
	this.instance_1.cache(-2,-2,64,73);

	this.instance_2 = new lib.SheepHoof();
	this.instance_2.parent = this;
	this.instance_2.setTransform(59.1,80.4,0.541,0.64,0,0.9,-174.4,11.9,9.9);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,0);
	this.instance_2.filters = [new cjs.ColorFilter(0.53, 0.53, 0.53, 1, 0, 0, 0, 0)];
	this.instance_2.cache(-2,-2,24,15);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#464A53").s().p("ABRBVQgEgCgQgTQgCgCgJgCQgKgCgCACQgRAJgKgHIgLgKIgOgdIgegcQgagZgfAFQggAEAAgQQAGgmgBgEQgDgLAbACQgJgMAdAFQAdAEA6AjQA8AjAeAhQAdAhADALQADALADgGQAEgGgBAVQgBAVgPAAQgOAAgXgMg");
	this.shape.setTransform(51.4,71.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepbackLeg_excited_003copy, new cjs.Rectangle(-7.1,-8.1,78.1,94.6), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.SheepTorso_excited_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Body
	this.instance = new lib.SheepWool();
	this.instance.parent = this;
	this.instance.setTransform(-40,-1.3,1.194,1.083,0,0,0,39.6,60);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_1 = new lib.SheepWool2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-14.6,-0.9,1,1.016,-7.8,0,0,40.3,63.5);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_2 = new lib.SheepWool();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.1,-8.8,1.194,1.11,180,0,0,39.6,59.9);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.SheepTorso_excited_006, new cjs.Rectangle(-97.9,-78.2,176.7,153.9), null);


(lib.SheepTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":70});

	// Fluff
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-39.9,-111.6,0.804,0.804,178.1,0,0,35.8,11.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-50.7,-73.3,0.713,0.713,-23.7,0,0,36,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-18.4,-92.5,0.804,0.804,178.1,0,0,35.8,11.2);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-73.6,-95,0.906,0.907,0,-12.7,-16,35.8,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},69).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SheepTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":62,"glowclean_loop":63,"final":64,"final_loop":65});

	// Layer 3
	this.instance = new lib.SheepTorso0001();
	this.instance.parent = this;
	this.instance.setTransform(-99.1,-78,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(21.5,-39.5,1,1,0,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(8.2,-48.4,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles_2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(6.8,-34.7,1,1,0,0,0,48.9,4.8);

	this.instance_4 = new lib.left_over_bubbles();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-26.6,-41.1,1,1,0,0,0,50.6,5.2);

	this.instance_5 = new lib.SheepTorso0002();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-99.1,-78,0.5,0.5);

	this.instance_6 = new lib.sheep_backGlow();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-11,-47.9,1.402,1.402,0,0,0,42.4,17.2);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-11,-47.9,1.402,1.402,0,0,0,42.4,17.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_6}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},47).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(95));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-99.1,-78.2,180,155.2);


(lib.SheepNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":54});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-24.8,26.4,0.631,0.631,20.7,0,0,36,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-32,0.9,0.713,0.713,20.7,0,0,35.8,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},53).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SheepNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":62,"glowclean_loop":63,"final":64,"final_loop":65});

	// Layer 4
	this.instance = new lib.SheepNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-42.1,-46.2,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(3.7,27.4,1,1,45,0,0,50.5,5.2);

	this.instance_2 = new lib.SheepNeck0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42.1,-46.2,0.5,0.5);

	this.instance_3 = new lib.sheep_neckGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-11.2,28.2,1.309,1.309,0,0,0,21.4,52.1);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(-11.2,28.2,1.309,1.309,0,0,0,21.4,52.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2},{t:this.instance_1}]},47).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(95));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.1,-46.2,88,114);


(lib.SheepHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":63});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-95.2,58.8,0.804,0.804,-87.5,0,0,35.9,11.5);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-96.2,29.5,0.804,0.804,-87.5,0,0,35.9,11.5);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-15.2,46.4,0.804,0.804,-87.5,0,0,35.9,11.5);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(35.2,5.4,0.804,0.804,-87.5,0,0,35.9,11.5);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(3.1,-10,0.713,0.713,70.7,0,0,35.8,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(12.4,20.7,0.804,0.804,-87.5,0,0,36.9,10.6);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(20.3,-26.8,0.713,0.713,70.7,0,0,35.8,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},62).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SheepHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":52});

	// Layer 7
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(0,8.5,0.311,0.311,-137.4,0,0,35.8,11.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-17.3,12.6,0.519,0.519,20.7,0,0,35.8,11.1);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-9.2,12,0.314,0.314,-137.4,0,0,35.8,11.5);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-7.4,13.5,0.713,0.713,20.7,0,0,35.8,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},51).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SheepHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 2
	this.instance = new lib.SheepHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-26.4,-33.4,0.5,0.5);

	this.instance_1 = new lib.SheepHead_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-26.4,-33.4,0.5,0.5);

	this.instance_2 = new lib.sheep_noseGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-6.6,10.2,1.161,1.161,0,0,0,15.7,13.3);

	this.glow = new lib.noseglowblue();
	this.glow.parent = this;
	this.glow.setTransform(-6.6,10.2,1.161,1.161,0,0,0,15.7,13.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},54).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(96));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-26.4,-33.4,83,68);


(lib.SheepFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":90,"glowclean":91,"glowclean_loop":92,"final":93,"final_loop":94});

	// Layer 5
	this.instance = new lib.SheepFrontLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-36.2,-61.8,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(119.1,12.6,1,1,0,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(121.3,-3.7,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles_sparse();
	this.instance_3.parent = this;
	this.instance_3.setTransform(108.8,17.8,1,1,-75,0,0,47.6,10.2);

	this.instance_4 = new lib.left_over_bubbles_sparse();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-9.7,36.3,1,1,60,0,0,47.6,10.2);

	this.instance_5 = new lib.SheepFrontLeg0002();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-36.2,-61.8,0.5,0.5);

	this.instance_6 = new lib.sheep_legGlow();
	this.instance_6.parent = this;
	this.instance_6.setTransform(51.2,16.2,1.308,1.308,0,0,0,-8.5,57.7);

	this.glow = new lib.legsblueglow();
	this.glow.parent = this;
	this.glow.setTransform(51.2,16.2,1.308,1.308,0,0,0,-8.5,57.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_6}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},77).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(66));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-61,-61.8,105.8,164);


(lib.water_drops_014 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,10.7,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(174.5,47.7,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(20,71.3,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(42.4,57.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(214.7,42.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.SheepHead_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 4
	this.instance = new lib.sheep_noseGlow();
	this.instance.parent = this;
	this.instance.setTransform(4.5,14.3,1.161,1.161,0,165,-15,15.7,13.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(155));

	// Layer 8
	this.instance_1 = new lib.SheepHead_001_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.7,5.1,1,1,0,0,0,-14.2,6.6);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6).to({_off:false},0).to({_off:true},149).wait(6));

	// Ear
	this.instance_2 = new lib.sheep_mouthMud_001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(2.6,17.8,1,1,0,165,-15,17.2,11.2);

	this.instance_3 = new lib.SheepHead_0070002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-25.9,-38.7,0.5,0.5);

	this.glow = new lib.bluenoseglow5();
	this.glow.parent = this;
	this.glow.setTransform(4.4,12.7,0.799,0.999,-29.9,0,0,15.5,13.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.glow}]},150).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.9,-38.7,68,79);


(lib.SheepHead_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 8
	this.instance = new lib.sheep_noseGlow();
	this.instance.parent = this;
	this.instance.setTransform(4.1,11.7,1.161,1.161,0,0,0,15.7,13.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(155));

	// Layer 14
	this.instance_1 = new lib.SheepHead_001_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-13.9,3.5,1,1,0,0,0,-14.2,6.6);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6).to({_off:false},0).to({_off:true},149).wait(6));

	// Layer 3
	this.instance_2 = new lib.sheep_mouthMud_001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(1,16.2,1,1,0,180,0,17.2,11.2);

	this.instance_3 = new lib.SheepHead_0060002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-19,-38.5,0.5,0.5);

	this.glow = new lib.bluenoseglow4();
	this.glow.parent = this;
	this.glow.setTransform(1.1,11.7,1,1.161,-30,0,0,15.6,13.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2,p:{x:1,y:16.2}}]}).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2,p:{x:0.6,y:16.5}}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.glow}]},150).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21.2,-38.5,68,78);


(lib.SheepHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 4
	this.instance = new lib.sheep_noseGlow();
	this.instance.parent = this;
	this.instance.setTransform(-1.8,13,1.161,1.161,0,0,0,15.7,13.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(155));

	// Layer 8
	this.instance_1 = new lib.SheepHead_001_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-16.5,2.6,1,1,0,0,0,-14.2,6.6);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6).to({_off:false},0).to({_off:true},149).wait(6));

	// Layer 2
	this.instance_2 = new lib.sheep_mouthMud_001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-3.7,16.5,1,1,0,180,0,17.2,11.2);

	this.instance_3 = new lib.SheepHead_0050002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-22,-35.9,0.5,0.5);

	this.glow = new lib.bluenoseglow3();
	this.glow.parent = this;
	this.glow.setTransform(-1.8,13,1.161,1.161,0,0,0,15.7,13.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.glow}]},150).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(1));

	// Layer 7
	this.instance_4 = new lib.sheep_mouthMud_001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-0.4,12.4,1.035,1.129,0,-46.9,-30,17.1,11.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({_off:true},1).wait(160));

	// Ear A
	this.instance_5 = new lib.SheepEarA_006();
	this.instance_5.parent = this;
	this.instance_5.setTransform(30.7,-22.1,1.771,1.771,0,4.5,-175.5,4.6,7.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1).to({_off:true},1).wait(159));

	// Head Wool
	this.instance_6 = new lib.SheepForeheadWool_005();
	this.instance_6.parent = this;
	this.instance_6.setTransform(11.2,-11.7,1.771,1.771,0,23,-157,10.3,9);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1).to({_off:true},1).wait(159));

	// Nose
	this.instance_7 = new lib.SheepNose_005();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-12.5,13.4,1.771,1.771,0,0,180,2.7,2.5);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(1).to({_off:true},1).wait(159));

	// Eye
	this.instance_8 = new lib.SheepEye_001();
	this.instance_8.parent = this;
	this.instance_8.setTransform(8.1,-7.9,1.771,1.771,0,0,180,1.8,1.7);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(1).to({_off:true},1).wait(159));

	// Layer 5
	this.instance_9 = new lib.SheepFaceSnout_005();
	this.instance_9.parent = this;
	this.instance_9.setTransform(1.7,-1.3,1.771,1.771,0,0,180,11.3,14.3);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(1).to({_off:true},1).wait(159));

	// Layer 9
	this.instance_10 = new lib.SheepEye_001();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-7.3,-7.8,1.209,1.422,0,0,180,1.7,1.7);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1).to({_off:true},1).wait(159));

	// Layer 11
	this.instance_11 = new lib.SheepHeadWool_005();
	this.instance_11.parent = this;
	this.instance_11.setTransform(13.3,-9.6,1.94,1.771,0,2.9,-177.1,10.8,11.3);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1).to({_off:true},1).wait(159));

	// Layer 12
	this.instance_12 = new lib.SheepEarB_005();
	this.instance_12.parent = this;
	this.instance_12.setTransform(8.6,-25,1.771,1.771,0,21,-159,2.4,5.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(1).to({_off:true},1).wait(159));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.2,-35.9,74.3,74);


(lib.SheepHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Layer 4
	this.instance = new lib.sheep_noseGlow();
	this.instance.parent = this;
	this.instance.setTransform(-6.6,10.2,1.161,1.161,0,0,0,15.7,13.3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(155));

	// Layer 8
	this.instance_1 = new lib.SheepHead_001_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-16.5,2.6,1,1,0,0,0,-14.2,6.6);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(6).to({_off:false},0).to({_off:true},149).wait(6));

	// Layer 2
	this.instance_2 = new lib.SheepHead_0030001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-26,-34.2,0.5,0.5);

	this.instance_3 = new lib.SheepHead_0030002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-26,-34.2,0.5,0.5);

	this.glow = new lib.bluenoseglow2();
	this.glow.parent = this;
	this.glow.setTransform(-6.6,10.2,1.161,1.161,0,0,0,15.7,13.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.glow}]},150).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-26,-34.2,78,68);


(lib.Sheep = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:44,rest_stop:166,wet:168,wet_stop:174,"clean":176,clean_stop:186,excited:188,excited_stop:244,animalSound:278});

	// timeline functions:
	this.frame_42 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_166 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_174 = function() {
		/* stop();*/
	}
	this.frame_186 = function() {
		/* stop();*/
	}
	this.frame_276 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_302 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(42).call(this.frame_42).wait(124).call(this.frame_166).wait(8).call(this.frame_174).wait(12).call(this.frame_186).wait(90).call(this.frame_276).wait(26).call(this.frame_302).wait(1));

	// Layer 2
	this.mouth_bubbles = new lib.SheepHead_001_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(117.5,167.9,0.807,0.807);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).wait(44).to({_off:true},124).wait(135));

	// Layer 7
	this.legs_bubbles = new lib.SheepHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(235.1,190,0.676,0.676,0,0,0,-1.2,-13);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(44).to({_off:true},124).wait(135));

	// Sheep Neck
	this.neck_bubbles = new lib.SheepNeck_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(149.4,188.7,0.676,0.676);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).wait(44).to({x:153.2,y:194.7},0).to({_off:true},124).wait(135));

	// sparkle
	this.back_bubbles = new lib.SheepTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(226.8,220.5,0.676,0.62);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(44).to({x:225.2},0).to({_off:true},124).wait(135));

	// Layer 4
	this.instance = new lib.water_drops_014();
	this.instance.parent = this;
	this.instance.setTransform(179.1,197.6,0.6,0.6,0,0,180,132.4,67);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(168).to({_off:false},0).to({_off:true},8).wait(127));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(112.7,172.6,0.679,0.679,0,0,180);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(272).to({_off:false},0).to({_off:true},6).wait(25));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(149.6,146.8,0.605,0.605,0,0,180);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(258).to({_off:false},0).to({_off:true},20).wait(25));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(232.6,248.2,0.679,0.679,0,0,180);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(246).to({_off:false},0).to({_off:true},32).wait(25));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(179.3,230.1,0.665,0.665,0,0,180);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(236).to({_off:false},0).to({_off:true},42).wait(25));

	// Sheep Head_001
	this.sheep_head = new lib.SheepHead_001();
	this.sheep_head.parent = this;
	this.sheep_head.setTransform(117.5,167.9,0.807,0.807);

	this.sheep_head_1 = new lib.SheepHead_003();
	this.sheep_head_1.parent = this;
	this.sheep_head_1.setTransform(117.5,167.9,0.807,0.807);

	this.sheep_head_2 = new lib.SheepHead_005();
	this.sheep_head_2.parent = this;
	this.sheep_head_2.setTransform(117.5,167.9,0.807,0.807);

	this.sheep_head_3 = new lib.SheepHead_006();
	this.sheep_head_3.parent = this;
	this.sheep_head_3.setTransform(117.5,167.9,0.807,0.807);

	this.sheep_head_4 = new lib.SheepHead_007();
	this.sheep_head_4.parent = this;
	this.sheep_head_4.setTransform(117.5,167.9,0.807,0.807);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sheep_head}]}).to({state:[{t:this.sheep_head_1}]},2).to({state:[{t:this.sheep_head_2}]},2).to({state:[{t:this.sheep_head_3}]},2).to({state:[{t:this.sheep_head_4}]},2).to({state:[{t:this.sheep_head_3}]},26).to({state:[{t:this.sheep_head_2}]},2).to({state:[{t:this.sheep_head_1}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},4).to({state:[{t:this.sheep_head_1}]},32).to({state:[{t:this.sheep_head_2}]},2).to({state:[{t:this.sheep_head_3}]},2).to({state:[{t:this.sheep_head_4}]},2).to({state:[{t:this.sheep_head_3}]},52).to({state:[{t:this.sheep_head_2}]},2).to({state:[{t:this.sheep_head_1}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},28).to({state:[{t:this.sheep_head}]},8).to({state:[{t:this.sheep_head}]},12).to({state:[{t:this.sheep_head}]},12).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},10).to({state:[{t:this.sheep_head}]},38).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},8).to({state:[{t:this.sheep_head}]},2).to({state:[{t:this.sheep_head}]},2).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_head).to({_off:true},2).wait(38).to({_off:false},0).wait(4).to({_off:true},32).wait(64).to({_off:false},0).wait(48).to({regX:23.6,x:136.5},0).wait(14).to({regX:23.8,regY:-0.1,scaleX:0.81,scaleY:0.81,rotation:-9.8,x:136.6,y:177.8},0).wait(2).to({regX:23.6,regY:0,rotation:-19.8,x:136.5,y:187.8},0).wait(2).to({regX:23.4,regY:-0.1,scaleX:0.81,scaleY:0.81,rotation:-30,x:136.4,y:197.9},0).wait(2).to({regX:23.6,scaleX:0.81,scaleY:0.81,rotation:-12,x:142.6,y:172.1},0).wait(2).to({regX:23.4,rotation:5.8,x:148.6,y:146.4},0).wait(2).to({regX:23.6,scaleX:0.81,scaleY:0.81,rotation:23.7,x:154.8,y:120.7},0).wait(2).to({regX:23.7,scaleX:0.81,scaleY:0.81,rotation:19.3,x:142.5,y:150},0).wait(2).to({regY:0.1,scaleX:0.81,scaleY:0.81,rotation:15,x:130.1,y:179.2},0).wait(2).to({regX:23.6,rotation:0,x:137.6,y:190.6},0).wait(2).to({regX:23.4,scaleX:0.81,scaleY:0.81,rotation:-8.8,x:136.1,y:198.3},0).wait(2).to({regY:0,scaleX:0.81,scaleY:0.81,rotation:-17.7,x:135,y:205.8},0).wait(2).to({regY:-0.1,rotation:-30,x:136.4,y:197.9},0).wait(2).to({regX:23.6,scaleX:0.81,scaleY:0.81,rotation:-19.8,x:136.5,y:187.8},0).wait(2).to({regX:23.5,rotation:-9.8,y:177.8},0).wait(2).to({regX:23.6,regY:0,scaleX:0.81,scaleY:0.81,rotation:0,y:167.9},0).wait(50).to({regX:23.5,regY:-0.1,scaleX:0.81,scaleY:0.81,rotation:-9.8,y:177.8},0).wait(2).to({regX:23.6,rotation:-19.8,y:187.8},0).wait(2).to({regX:23.4,scaleX:0.81,scaleY:0.81,rotation:-30,x:136.4,y:197.9},0).wait(8).to({regX:23.6,scaleX:0.81,scaleY:0.81,rotation:-19.8,x:136.5,y:187.8},0).wait(2).to({regX:23.5,rotation:-9.8,y:177.8},0).wait(2).to({regX:23.6,regY:0,scaleX:0.81,scaleY:0.81,rotation:0,y:167.9},0).wait(7));

	// Sheep Front Leg
	this.sheep_frontleg = new lib.SheepFrontLeg();
	this.sheep_frontleg.parent = this;
	this.sheep_frontleg.setTransform(168.7,190.5,0.676,0.676,0,0,0,0,-17.8);

	this.sheep_frontleg_1 = new lib.SheepLegA_104_1();
	this.sheep_frontleg_1.parent = this;
	this.sheep_frontleg_1.setTransform(153.5,264.2,1,1,0,-8.8,171.2,59.1,91.5);

	this.sheep_frontleg_2 = new lib.SheepLegA_108_1();
	this.sheep_frontleg_2.parent = this;
	this.sheep_frontleg_2.setTransform(165.2,197.4,1,1,0,-4.5,175.5,31.8,39.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sheep_frontleg}]}).to({state:[{t:this.sheep_frontleg}]},44).to({state:[{t:this.sheep_frontleg}]},124).to({state:[{t:this.sheep_frontleg}]},8).to({state:[{t:this.sheep_frontleg}]},12).to({state:[{t:this.sheep_frontleg}]},12).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg_1,p:{regX:59.1,regY:91.5,skewX:-8.8,skewY:171.2,x:153.5,y:264.2}}]},2).to({state:[{t:this.sheep_frontleg_2,p:{regX:31.8,regY:39.5,skewX:-4.5,skewY:175.5,x:165.2,y:197.4}}]},2).to({state:[{t:this.sheep_frontleg_2,p:{regX:26.3,regY:43.9,skewX:-2.6,skewY:177.4,x:171,y:176.9}}]},2).to({state:[{t:this.sheep_frontleg_2,p:{regX:31.8,regY:39.4,skewX:-7.5,skewY:172.5,x:165.6,y:184.5}}]},2).to({state:[{t:this.sheep_frontleg_1,p:{regX:59,regY:92.2,skewX:-15,skewY:165,x:152.3,y:262.4}}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},10).to({state:[{t:this.sheep_frontleg}]},38).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},8).to({state:[{t:this.sheep_frontleg}]},2).to({state:[{t:this.sheep_frontleg}]},2).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_frontleg).wait(202).to({regX:0.1,scaleY:0.65,skewX:1.3,x:170.4,y:193.2},0).wait(2).to({regX:1.4,scaleY:0.63,skewX:2.8,x:172.9,y:195.8},0).wait(2).to({regX:0.1,regY:-17.7,scaleY:0.61,skewX:4.1,x:173.6,y:198.5},0).to({_off:true},2).wait(10).to({_off:false,regY:-17.8,scaleY:0.57,skewX:4.4,y:202.2},0).wait(2).to({scaleY:0.59,skewX:4.3,x:173.7,y:200.3},0).wait(2).to({regY:-17.7,scaleY:0.61,skewX:4.1,x:173.6,y:198.5},0).wait(4).to({regX:1.4,regY:-17.8,scaleY:0.63,skewX:2.8,x:172.9,y:195.7},0).wait(2).to({regX:0.1,regY:-17.7,scaleY:0.65,skewX:1.3,x:170.4,y:193.1},0).wait(2).to({regX:0,regY:-17.8,scaleY:0.68,skewX:0,x:168.7,y:190.5},0).wait(50).to({regX:0.1,regY:-17.7,scaleY:0.65,skewX:1.3,x:170.4,y:193.1},0).wait(2).to({regX:1.5,regY:-17.8,scaleY:0.63,skewX:2.8,x:173,y:195.7},0).wait(2).to({regX:0.1,regY:-17.7,scaleY:0.61,skewX:4.1,x:173.6,y:198.5},0).wait(8).to({regX:1.6,regY:-17.8,scaleY:0.63,skewX:2.8,x:173.1,y:195.7},0).wait(2).to({regX:0.1,regY:-17.7,scaleY:0.65,skewX:1.3,x:170.4,y:193.1},0).wait(2).to({regX:0,regY:-17.8,scaleY:0.68,skewX:0,x:168.7,y:190.5},0).wait(7));

	// Sheep Hind Leg
	this.sheep_hindleg = new lib.SheepHindLeg();
	this.sheep_hindleg.parent = this;
	this.sheep_hindleg.setTransform(235.1,190,0.676,0.676,0,0,0,-1.2,-13);

	this.sheep_hindleg_1 = new lib.SheepHindLeg_excited_1();
	this.sheep_hindleg_1.parent = this;
	this.sheep_hindleg_1.setTransform(235.1,190,0.676,0.676,0,0,0,-1.2,-13);
	this.sheep_hindleg_1._off = true;

	this.sheep_hindleg_2 = new lib.SheepHindLeg_excited_002_1();
	this.sheep_hindleg_2.parent = this;
	this.sheep_hindleg_2.setTransform(223.5,167.4,0.676,0.712,0,-19.3,-15,-1.2,-13);
	this.sheep_hindleg_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.sheep_hindleg).wait(176).to({_off:true},12).wait(115));
	this.timeline.addTween(cjs.Tween.get(this.sheep_hindleg_1).wait(188).to({_off:false},0).wait(14).to({regY:-13.1,scaleY:0.66,skewX:0.5,x:234.6,y:192.2},0).wait(2).to({regY:-12.9,scaleY:0.64,skewX:1,x:234.1,y:194.6},0).wait(2).to({regX:-7.4,regY:-13,scaleY:0.62,skewX:1.5,x:232.7,y:196.8},0).wait(2).to({regX:-6.2,scaleY:0.65,skewX:-0.3,x:232,y:193.3},0).wait(2).to({scaleY:0.68,skewX:-2.3,x:230.4,y:189.9},0).wait(2).to({regX:-1.9,scaleY:0.71,skewX:-4.3,x:228.8,y:186.4},0).wait(2).to({y:175.9},0).to({_off:true},2).wait(8).to({_off:false,regX:-7.5,scaleY:0.62,skewX:1.5,x:232.7,y:196.8},0).wait(2).to({regX:-6.3,regY:-13.1,scaleY:0.64,skewX:1,x:234.1,y:194.5},0).wait(2).to({regX:-6.2,scaleY:0.66,skewX:0.5,x:234.7,y:192.1},0).wait(2).to({regX:-1.2,regY:-13,scaleY:0.68,skewX:0,x:235.1,y:190},0).wait(50).to({regX:-6.2,regY:-13.1,scaleY:0.66,skewX:0.5,x:234.7,y:192.1},0).wait(2).to({regX:-6.3,scaleY:0.64,skewX:1,x:234.1,y:194.5},0).wait(2).to({regX:-7.7,regY:-13,scaleY:0.62,skewX:1.5,x:232.5,y:196.8},0).wait(8).to({regX:-6.3,regY:-13.1,scaleY:0.64,skewX:1,x:234.1,y:194.5},0).wait(2).to({regX:-6.2,scaleY:0.66,skewX:0.5,x:234.7,y:192.1},0).wait(2).to({regX:-1.2,regY:-13,scaleY:0.68,skewX:0,x:235.1,y:190},0).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_hindleg_2).wait(216).to({_off:false},0).wait(2).to({regY:-12.9,skewX:-26.3,skewY:-22,x:220.2,y:175},0).wait(2).to({regY:-13,scaleY:0.71,skewX:-15.5,skewY:-11.1,x:226.6,y:176.8},0).wait(2).to({regX:0.5,regY:-18.9,scaleY:0.71,skewX:-4.7,skewY:-0.4,x:232.9,y:177.7},0).to({_off:true},2).wait(79));

	// Sheep Neck
	this.sheep_neck = new lib.SheepNeck();
	this.sheep_neck.parent = this;
	this.sheep_neck.setTransform(138.9,178.7,0.676,0.676);

	this.sheep_neck_1 = new lib.SheepNeck_excited_1();
	this.sheep_neck_1.parent = this;
	this.sheep_neck_1.setTransform(138.9,178.7,0.676,0.676);
	this.sheep_neck_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.sheep_neck).wait(4).to({scaleY:0.68,skewX:-1.5,x:138.1,y:179},0).wait(2).to({scaleY:0.68,skewX:-3.1,x:137.3,y:179.2},0).wait(2).to({scaleY:0.68,skewX:-4.8,x:136.5,y:179.5},0).wait(28).to({scaleY:0.68,skewX:-3.1,x:137.3,y:179.2},0).wait(2).to({scaleY:0.68,skewX:-1.5,x:138,y:179},0).wait(2).to({scaleY:0.68,skewX:0,x:138.9,y:178.7},0).wait(38).to({scaleY:0.68,skewX:-1.5,x:138.1,y:179},0).wait(2).to({scaleY:0.68,skewX:-3.1,x:137.3,y:179.2},0).wait(2).to({scaleY:0.68,skewX:-4.8,x:136.5,y:179.5},0).wait(54).to({scaleY:0.68,skewX:-3.1,x:137.3,y:179.2},0).wait(2).to({scaleY:0.68,skewX:-1.5,x:138,y:179},0).wait(2).to({scaleY:0.68,skewX:0,x:138.9,y:178.7},0).wait(36).to({_off:true},12).wait(115));
	this.timeline.addTween(cjs.Tween.get(this.sheep_neck_1).wait(188).to({_off:false},0).wait(14).to({rotation:-12.8,x:141.2,y:184.7},0).wait(2).to({rotation:-25.6,x:143.4,y:190.8},0).wait(2).to({rotation:-38.5,x:145.7,y:196.9},0).wait(2).to({rotation:-17.6,x:148,y:175.1},0).wait(2).to({rotation:3,x:150.3,y:153.4},0).wait(2).to({rotation:23.7,x:152.5,y:131.7},0).wait(2).to({rotation:4.3,x:145,y:159.5},0).wait(2).to({rotation:-15,x:137.5,y:187.2},0).wait(2).to({x:148.2,y:197.4},0).wait(2).to({rotation:-23.8,x:147.8,y:203.2},0).wait(2).to({rotation:-32.7,x:147.4,y:209.1},0).wait(2).to({rotation:-38.5,x:145.7,y:196.9},0).wait(2).to({rotation:-25.6,x:143.5,y:190.8},0).wait(2).to({rotation:-12.8,x:141.2,y:184.7},0).wait(2).to({rotation:0,x:138.9,y:178.7},0).wait(50).to({rotation:-12.8,x:141.2,y:184.7},0).wait(2).to({rotation:-25.6,x:143.5,y:190.8},0).wait(2).to({rotation:-38.5,x:145.7,y:196.9},0).wait(8).to({rotation:-25.6,x:143.5,y:190.8},0).wait(2).to({rotation:-12.8,x:141.2,y:184.7},0).wait(2).to({rotation:0,x:138.9,y:178.7},0).wait(7));

	// Sheep Torso
	this.sheep_torso = new lib.SheepTorso();
	this.sheep_torso.parent = this;
	this.sheep_torso.setTransform(200.1,193.4,0.676,0.62);

	this.sheep_torso_1 = new lib.SheepTorso_excited_1();
	this.sheep_torso_1.parent = this;
	this.sheep_torso_1.setTransform(200.1,193.4,0.676,0.62);
	this.sheep_torso_1._off = true;

	this.sheep_torso_2 = new lib.SheepTorso_excited_006();
	this.sheep_torso_2.parent = this;
	this.sheep_torso_2.setTransform(200.1,193.4,0.676,0.62);
	this.sheep_torso_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.sheep_torso).wait(176).to({_off:true},12).wait(115));
	this.timeline.addTween(cjs.Tween.get(this.sheep_torso_1).wait(188).to({_off:false},0).wait(14).to({y:195.5},0).wait(2).to({y:197.6},0).wait(2).to({y:199.7},0).wait(2).to({scaleY:0.62,rotation:4.8,x:200.4,y:192.3},0).wait(2).to({rotation:14.3,x:201.5,y:181},0).wait(2).to({scaleY:0.62,rotation:23.7,x:202.6,y:169.8},0).wait(2).to({scaleY:0.62,rotation:3.3,x:201.8,y:175.9},0).wait(2).to({scaleY:0.62,rotation:-16.9,x:201.1,y:182.1},0).wait(2).to({scaleX:0.63,rotation:-11.1,x:195.4,y:199.2},0).wait(2).to({scaleX:0.65,scaleY:0.62,rotation:-12.3,x:200.3,y:200.1},0).wait(2).to({scaleX:0.68,scaleY:0.62,rotation:-13.5,x:205.3,y:200.9},0).wait(2).to({rotation:0,x:200.1,y:199.7},0).wait(2).to({y:197.6},0).wait(2).to({y:195.5},0).to({_off:true},2).wait(50).to({_off:false},0).wait(2).to({y:197.6},0).wait(2).to({y:199.7},0).wait(8).to({y:197.6},0).wait(2).to({y:195.5},0).to({_off:true},2).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_torso_2).wait(230).to({_off:false},0).wait(48).to({_off:true},2).wait(16).to({_off:false},0).wait(7));

	// Sheep Tail
	this.instance_5 = new lib.SheepTail();
	this.instance_5.parent = this;
	this.instance_5.setTransform(253.2,168.5,1,1,0,0,0,2.9,3.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(202).to({x:252.5,y:170.9},0).wait(2).to({rotation:-15.3,x:252.4,y:173.1},0).wait(2).to({x:251.6,y:174.6},0).wait(2).to({x:253.5,y:176.8},0).wait(2).to({x:250.9,y:170.7},0).wait(2).to({regX:2.8,regY:3,rotation:-2.3,x:251.8,y:171.6},0).wait(2).to({regX:2.7,regY:3.1,rotation:-20.2,x:252.3,y:164.1},0).wait(2).to({rotation:-42.9,x:247.2,y:155.5},0).wait(2).to({regY:3,rotation:-69.1,x:242.2,y:158.5},0).wait(2).to({x:243.9,y:161.3},0).wait(2).to({rotation:-50.4,x:248.6,y:162.3},0).wait(2).to({x:255.4,y:177.2},0).wait(2).to({x:253.1,y:173.4},0).wait(2).to({regX:0,regY:0,rotation:0,x:251,y:167.7},0).wait(2).to({regX:2.9,regY:3.1,x:253.2,y:168.5},0).wait(50).to({x:255.4,y:171.7},0).wait(2).to({x:254.6,y:174.5},0).wait(2).to({regX:0,regY:0,x:250.4,y:174.7},0).wait(8).to({x:250.8,y:172.6},0).wait(2).to({x:250.2,y:168.3},0).wait(2).to({regX:2.9,regY:3.1,x:253.2,y:168.5},0).wait(7));

	// Sheep Front Leg Back
	this.sheep_frontlegback = new lib.SheepFrontLegBack();
	this.sheep_frontlegback.parent = this;
	this.sheep_frontlegback.setTransform(170.9,204.4,0.676,0.676);

	this.sheep_frontlegback_1 = new lib.SheepbackLeg_excited_003_1();
	this.sheep_frontlegback_1.parent = this;
	this.sheep_frontlegback_1.setTransform(164.9,204.4,0.861,0.861,0,-44.5,135.5,31.6,39.5);

	this.sheep_frontlegback_2 = new lib.SheepbackLeg_excited_003copy();
	this.sheep_frontlegback_2.parent = this;
	this.sheep_frontlegback_2.setTransform(163.9,178.9,0.861,0.861,0,-29.5,150.5,31.7,39.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sheep_frontlegback}]}).to({state:[{t:this.sheep_frontlegback}]},44).to({state:[{t:this.sheep_frontlegback}]},124).to({state:[{t:this.sheep_frontlegback}]},8).to({state:[{t:this.sheep_frontlegback}]},12).to({state:[{t:this.sheep_frontlegback}]},12).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback_1,p:{regX:31.6,x:164.9,y:204.4}}]},2).to({state:[{t:this.sheep_frontlegback_2,p:{scaleX:0.861,scaleY:0.861,skewX:-29.5,skewY:150.5,x:163.9,y:178.9}}]},2).to({state:[{t:this.sheep_frontlegback_2,p:{scaleX:0.86,scaleY:0.86,skewX:-37.1,skewY:142.9,x:164.5,y:196.4}}]},2).to({state:[{t:this.sheep_frontlegback_1,p:{regX:31.4,x:165,y:213.8}}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},10).to({state:[{t:this.sheep_frontlegback}]},38).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},8).to({state:[{t:this.sheep_frontlegback}]},2).to({state:[{t:this.sheep_frontlegback}]},2).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_frontlegback).wait(202).to({scaleY:0.65,skewX:1.3,x:172.2,y:206.5},0).wait(2).to({scaleY:0.63,skewX:2.8,x:173.6,y:208.7},0).wait(2).to({scaleY:0.61,skewX:4.1,x:174.9,y:210.8},0).wait(2).to({regX:-0.1,regY:83.2,x:171.2,y:257.7},0).to({_off:true},2).wait(8).to({_off:false,regX:0,regY:0,scaleY:0.64,skewX:0,x:170.9,y:207.8},0).wait(2).to({scaleY:0.66,y:206.1},0).wait(2).to({scaleY:0.68,y:204.4},0).wait(2).to({scaleY:0.61,skewX:4.1,x:174.9,y:210.8},0).wait(2).to({scaleY:0.63,skewX:2.8,x:173.6,y:208.7},0).wait(2).to({scaleY:0.65,skewX:1.3,x:172.3,y:206.6},0).wait(2).to({scaleY:0.68,skewX:0,x:170.9,y:204.4},0).wait(50).to({scaleY:0.65,skewX:1.3,x:172.3,y:206.6},0).wait(2).to({scaleY:0.63,skewX:2.8,x:173.6,y:208.7},0).wait(2).to({scaleY:0.61,skewX:4.1,x:174.9,y:210.8},0).wait(8).to({scaleY:0.63,skewX:2.8,x:173.6,y:208.7},0).wait(2).to({scaleY:0.65,skewX:1.3,x:172.3,y:206.6},0).wait(2).to({scaleY:0.68,skewX:0,x:170.9,y:204.4},0).wait(7));

	// Sheep Hind Leg Back
	this.sheep_hindlegback = new lib.SheepHindLegBack();
	this.sheep_hindlegback.parent = this;
	this.sheep_hindlegback.setTransform(226.5,200.3,0.676,0.676);

	this.sheep_hindlegback_1 = new lib.SheepHindLegBack_excited_002_1();
	this.sheep_hindlegback_1.parent = this;
	this.sheep_hindlegback_1.setTransform(218.8,179.9,0.676,0.712,0,-19.3,-15);
	this.sheep_hindlegback_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.sheep_hindlegback).wait(202).to({scaleY:0.66,skewX:0.5,x:227.1,y:202.2},0).wait(2).to({scaleY:0.64,skewX:1,x:227.6,y:204.2},0).wait(2).to({scaleY:0.62,skewX:1.5,x:228.1,y:206.1},0).wait(2).to({scaleY:0.65,skewX:-0.3,x:225.9,y:203.1},0).wait(2).to({scaleY:0.68,skewX:-2.3,x:223.7,y:200.2},0).wait(2).to({scaleY:0.71,skewX:-4.3,x:221.5,y:197.2},0).wait(2).to({scaleY:0.71,skewX:-8.5,skewY:-4.1,y:192},0).to({_off:true},2).wait(8).to({_off:false,scaleY:0.62,skewX:1.5,skewY:0,x:228.1,y:206.1},0).wait(2).to({scaleY:0.64,skewX:1,x:227.5,y:204.2},0).wait(2).to({scaleY:0.66,skewX:0.5,x:227.1,y:202.2},0).wait(2).to({scaleY:0.68,skewX:0,x:226.5,y:200.3},0).wait(50).to({scaleY:0.66,skewX:0.5,x:227.1,y:202.2},0).wait(2).to({scaleY:0.64,skewX:1,x:227.5,y:204.2},0).wait(2).to({scaleY:0.62,skewX:1.5,x:228.1,y:206.1},0).wait(8).to({scaleY:0.64,skewX:1,x:227.5,y:204.2},0).wait(2).to({scaleY:0.66,skewX:0.5,x:227.1,y:202.2},0).wait(2).to({scaleY:0.68,skewX:0,x:226.5,y:200.3},0).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.sheep_hindlegback_1).wait(216).to({_off:false},0).wait(2).to({skewX:-17.3,skewY:-13,x:222.1,y:185.1},0).wait(2).to({scaleY:0.71,skewX:-11,skewY:-6.6,x:223.2,y:189},0).wait(2).to({scaleY:0.71,skewX:-4.7,skewY:-0.4,x:224.4,y:192.9},0).to({_off:true},2).wait(79));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(96.1,140.9,173,130.8);


(lib.sheep = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// noseGlow
	this.mouthGlow = new lib.sheep_noseGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(183.3,128.8,1,1,0,0,0,17.2,12.5);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.mouthGlow.cache(-4,-2,40,31);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// neckGlow
	this.neckGlow = new lib.sheep_neckGlow();
	this.neckGlow.parent = this;
	this.neckGlow.setTransform(204.6,136.1,1,1,0,0,0,22.8,35);
	this.neckGlow.alpha = 0;
	this.neckGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.neckGlow.cache(1,30,41,44);

	this.timeline.addTween(cjs.Tween.get(this.neckGlow).wait(1));

	// backGlow
	this.backGlow = new lib.sheep_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(271.9,115.1,1,1,0,0,0,43.1,17.2);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(-4,-4,93,43);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.sheep_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(319.5,170.6,1,1,0,0,0,27.5,57.4);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-76,-4,135,124);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// foot1
	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(238.6,223.5,0.915,0.56);

	this.timeline.addTween(cjs.Tween.get(this.foot1).wait(1));

	// foot
	this.foot = new lib.invisiblebox();
	this.foot.parent = this;
	this.foot.setTransform(300.1,219.8,1.074,0.56);

	this.timeline.addTween(cjs.Tween.get(this.foot).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(335.8,124.1,0.661,0.56);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// leg2
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(327.1,170.6,1.032,1.598,-176.7);

	this.timeline.addTween(cjs.Tween.get(this.leg2).wait(1));

	// leg1
	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(243.8,173.5,0.625,1.674,-177.5);

	this.timeline.addTween(cjs.Tween.get(this.leg1).wait(1));

	// tummy
	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(281.2,173.6,1.008,0.794,-88.1);

	this.timeline.addTween(cjs.Tween.get(this.tummy).wait(1));

	// neck
	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(207.5,140.9,1.249,0.638,0,-91.1,-59.4);

	this.timeline.addTween(cjs.Tween.get(this.neck).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(274.2,116.6,1.59,0.924);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// ear
	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(213.8,102.3,0.752,0.56);

	this.timeline.addTween(cjs.Tween.get(this.ear).wait(1));

	// mouth
	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(178.1,131.7,0.792,0.573,0,25.6,0);

	this.timeline.addTween(cjs.Tween.get(this.mouth).wait(1));

	// main
	this.main = new lib.Sheep();
	this.main.parent = this;
	this.main.setTransform(451.7,-5,1.117,1.117,0,0,180,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.sheep, new cjs.Rectangle(156.9,90.5,210.4,146), null);


// stage content:
(lib.MWsheep = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Sheep();
	this.instance.parent = this;
	this.instance.setTransform(300,181.1,1,1,0,0,180,192.8,206.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(523.7,269.2,173,130.8);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWsheep_atlas_.png?1528309907127", id:"MWsheep_atlas_"}
	],
	preloads: []
};




})(lib_Sheep = lib_Sheep||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Sheep, images, createjs, ss, AdobeAn;